// extracted by mini-css-extract-plugin
export var menus = "menus-module--menus--bhzXE";
export var menu = "menus-module--menu--faKmD";
export var navigation = "menus-module--navigation--5tw2x";